import { type ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { appConfig } from "../lib/config";
import { isSupabaseConfigured, supabase } from "../lib/supabase";

type SessionState = "checking" | "authenticated" | "anonymous";

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [state, setState] = useState<SessionState>(
    isSupabaseConfigured
      ? "checking"
      : appConfig.allowDemo
        ? "authenticated"
        : "anonymous",
  );

  useEffect(() => {
    if (!supabase) return;

    let mounted = true;
    void supabase.auth.getSession().then(({ data }) => {
      if (mounted) {
        setState(data.session ? "authenticated" : "anonymous");
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (mounted) {
        setState(session ? "authenticated" : "anonymous");
      }
    });

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="route-fallback" role="status">
        <span />
        Verificando acesso…
      </div>
    );
  }

  if (state === "anonymous") {
    return (
      <Navigate
        replace
        to="/auth"
        state={{ returnTo: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
}
